import globals from "./globals";
import $ from "cash-dom";

const component = (function () {
    $(window).on("load", function () {
        if ($(".lazy").length) {
            if (globals.debug) console.log("component-batch-load initialized");
            setTimeout(function () {
                $(".lazy").each(function (_i, _el) {
                    var data = {
                        src: $(_el).attr("data-src"),
                        srcset: $(_el).attr("data-srcset"),
                        sizes: $(_el).attr("data-sizes"),
                    };

                    $(_el)
                        .attr({
                            src: data.src,
                            srcset: data.srcset,
                            sizes: data.sizes,
                        })
                        .removeAttr("data-src data-srcset data-sizes");

                    $(_el).addClass("loaded");
                    $(_el).next().addClass("on");

                    if ($(_el).parents("video").length) {
                        $(_el).parents("video")[0].load();
                    }
                });
                if (globals.debug) console.log("images loaded");
                $("html").addClass("images-loaded");
            }, 0);
        }
    });
})();

export default component;
